import Component from './Component';

export default class SearchBar extends Component {
  load() {
    $('.search-bar__input').on('keypress', (e) => {
      const keycode = parseInt(e.keyCode ? e.keyCode : e.which);
      if (keycode === 13) {
        e.currentTarget.form.submit();
        e.stopPropagation();
        return false;
      }
    });

    super.load();
  }
}
